import styled from 'styled-components';
import React, { useState } from 'react';
import { DialogFullScreen } from '@spotify-internal/encore-web/core/components/DialogFullScreen';
import { useSecureFormPopupStore } from '../stores/secureFormPopupStore';
import { IconLocked } from '@spotify-internal/encore-web/core/components/Icon/icons/IconLocked';
import { useTranslation } from 'react-i18next';
const SecureFormCreditCardLink = styled.span `
  text-decoration: underline;
  cursor: pointer;
`;
const SecureFormIframe = styled.iframe `
  width: 100%;
  height: 100%;
  border: 0;
`;
const ErrorInfo = styled.div `
  width: 100%;
  height: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > div:nth-child(2) {
    margin-top: 0.5rem;
    text-align: center;
  }
`;
export const SecureFormPopup = ({ url, onClose, hide, error, title, }) => {
    const { i18n, t } = useTranslation();
    return (React.createElement(DialogFullScreen, { dir: i18n.dir(), dialogTitle: title, body: React.createElement(React.Fragment, null, !error ? (React.createElement(SecureFormIframe, { src: url, title: "Secure form iframe" })) : (React.createElement(ErrorInfo, null,
            React.createElement("div", null,
                React.createElement(IconLocked, null)),
            React.createElement("div", null, t('SECURE_FORM_ERROR_TEXT'))))), style: { display: hide ? 'none' : 'flex' }, bodyStyle: { padding: 0 }, onClose: onClose }));
};
export const SecureForm = ({ url, invitationId, from, title, }) => {
    const [hidden, setHidden] = useState(true);
    const [error, setError] = useState(false);
    const { setSecureFormPopupInfo } = useSecureFormPopupStore();
    const handleClick = (e) => {
        e.preventDefault();
        setSecureFormPopupInfo(url, invitationId, from, title, () => {
            setHidden(true);
        }, () => {
            setError(true);
        });
        setHidden(false);
    };
    return (React.createElement(React.Fragment, null,
        from,
        " has sent you a Secure Form:",
        ' ',
        React.createElement(SecureFormCreditCardLink, { onClick: handleClick }, title),
        React.createElement(SecureFormPopup, { url: url, error: error, hide: hidden, onClose: () => setHidden(true), title: title })));
};
//# sourceMappingURL=SecureForm.js.map